import { render, staticRenderFns } from "./InstitutionalEndowment.vue?vue&type=template&id=33c0200f&scoped=true&"
import script from "./InstitutionalEndowment.vue?vue&type=script&lang=js&"
export * from "./InstitutionalEndowment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c0200f",
  null
  
)

export default component.exports